import { Setting } from '@/model/Setting'
import { BaseService } from '../BaseService'
import { ServiceLocator } from '../ServiceLocator'
import { IRepresentationService } from './IRepresentationService'
import {
  getAllRegularRepresentations,
  Representation,
  RepresentationTypes,
  setCumulativeLegend,
} from '@/model/Representation'

export class RepresentationService extends BaseService implements IRepresentationService {
  public constructor(serviceLocator: ServiceLocator) {
    super(serviceLocator)
  }

  getAllRepresentations(): Promise<Representation<RepresentationTypes>[]> {
    throw new Error('Method not implemented.')
  }

  updateLegendFromSettings(settings: Setting): void {
    //todo add get legend key to representation
    for (const representation of getAllRegularRepresentations()) {
      switch (representation.type) {
        case 'flood risk':
          representation.legend = settings.getLegend('flood_risk')
          break
        case 'flood depth':
          representation.legend = settings.getLegend('flood_depth')
          break
        case 'rainfall':
          representation.legend = settings.getLegend('rainfall')
          break
        case 'return period':
          representation.legend = settings.getLegend('return_period')
          break
      }
    }

    setCumulativeLegend(settings.getLegend('rainfall'))
  }
}
